import { TFunction } from 'i18next';

export enum TrackingInterval {
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
  YEARLY = 'yearly',
}

export function getTrackingIntervalDisplay({
  interval,
  t,
}: {
  interval: TrackingInterval;
  t: TFunction<'subproject', 'TrackingInterval'>;
}) {
  switch (interval) {
    case TrackingInterval.WEEKLY:
      return t('weekly');
    case TrackingInterval.MONTHLY:
      return t('monthly');
    case TrackingInterval.YEARLY:
      return t('yearly');
  }
}
